import { useEffect, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { ROUTES } from "../utils/Routes";
import { listen } from "../hooks/Listener";
import { createModal } from "../hooks/createModal";
import Menu from "../ui/Menu";
import Card from "../ui/Card";
import Label from "../ui/Label";
import ReportsCustomInventory from "../components/ReportsCustomInventory";
import Divider from "../ui/Divider";
import Space from "../ui/Space";
import Nav from "../ui/Nav";
import ProcessingList from "../components/ProcessingList";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import ProcessingDetails from "../components/ProcessingDetails";
import { buildFileFromChunks } from "../utils/Utils";
import PurchaseOrderUpdate from "../popups/PurchaseOrderUpdate";
import { ENUMS } from "../utils/Enums";
import Spin from "../ui/Spin";

export default function OrderProcessingController(props) {

    const { signal = {}, setController = () => { } } = props;

    const route = ROUTES.PROCESSING.PROCESSING;
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});
    const [selectedItem, setSelectedItem] = useState({});
    const [items, setItems] = useState([]);
    const [align, setAlign] = useState("auto");
    const [view, setView] = useState(true);
    const [edit, setEdit] = useState(false);
    const [filters, setFilters] = useState({ limit: 45, sort: "status", send_via: "", minimum: "", pending_separators: "", supplier_types: "" })
    const row_key = "purchase_order_id";

    const processing_nav = [
        { key: KBD.ESCAPE, action: () => { setController("home") } },
        { text: "Edt" },
        { text: "Flt" },
        { text: "Indx" },
        { text: "Log" },
        { text: "Ok" },
        { key: KBD.P, text: "Process", action: () => { generate850(selected); } },
        { key: KBD.R, text: "Rettl", action: () => { reTotal(selected) } },
        { text: "Search" },
        { text: "Telephone" },
        { key: KBD.U, text: "Update", action: () => { drawUpdate() } },
        { text: "View" },
        { text: "Xtra" },
    ]

    useEffect(() => {
        window.bm_state.value = route;
        const cleanup = listen(route, processing_nav);
        return cleanup;
    }, [processing_nav, selected])


    const generate850 = (_selected = selected) => {
        setLoading(true);
        pubCall("purchase_order.generate850", { purchase_order_id: _selected?.[row_key] }, (_s, _r) => {
            if (_s) {
                buildFileFromChunks(_r, pubCall, setLoading, () => {
                    showMessage("File created successfully.")
                })
            } else {
                showError(_r);
            }
        })
    }


    const reTotal = (_selected = selected) => {
        setLoading(true)
        pubCall("purchase_order.retotal", { purchase_order_id: _selected?.[row_key] }, (_s, _r) => {
            if (_s) {
                console.log(JSON.stringify(_r, null, 2))
            } else {
                showError(_r);
            }
        })
    }

    const runUpdate = (_filters) => {
        setLoading(true)
        pubCall("purchase_order.update", _filters, (_s, _r) => {
            if (_s) {
                showMessage("Update complete.")
            } else {
                showError(_r);
            }
            setLoading(false)
        })
    }


    const drawUpdate = () => {
        window.bm_state.value = ROUTES.ORDERS.UPDATE;
        createModal({
            component: <PurchaseOrderUpdate filters={filters} options={ENUMS.ORDER_UPDATE_OPTIONS} route={ROUTES.ORDERS.UPDATE} />, closable: true, title: <>Update</>, callback: (_filter) => {
                if (_filter) {
                    runUpdate(_filter);
                }
                window.bm_state.value = route;
            }
        })
    }


    return (
        <div className="controller">
            <Spin loading={loading}>
                <div style={{ height: "calc(100vh - 74px)", minHeight: "600px", gap: "15px" }}>
                    <ProcessingDetails setSelectedItem={setSelectedItem} setSelected={setSelected} items={items} setItems={setItems} selected={selected} />
                    <div className="shim" />
                    <ProcessingList
                        loading={loading}
                        setLoading={setLoading}
                        route={route}
                        data={data}
                        setData={setData}
                        selected={selected}
                        setSelected={setSelected}
                        signal={signal}
                        align={align}
                        setAlign={setAlign}
                        view={view}
                        filters={filters}
                        setFilters={setFilters}
                        row_key={row_key}
                    />
                    <div className="shim" />
                    <Divider />
                    <div style={{ 'height': "30px" }}>
                        <Space style={{ "padding": "0px 15px" }}>
                            <Nav nav={processing_nav} />
                        </Space>
                    </div>
                </div>
            </Spin>
        </div>
    )
}


